import React, { createContext, useContext } from 'react';
import useDriverAccount from '../hooks/useDriverAccount';

const DriverContext = createContext();

export const DriverProvider = ({ children }) => {
  const driverAccountData = useDriverAccount();

  return (
    <DriverContext.Provider value={driverAccountData}>
      {children}
    </DriverContext.Provider>
  );
};

export const useDriver = () => {
  const context = useContext(DriverContext);
  if (!context) {
    throw new Error('useDriver must be used within a DriverProvider');
  }
  return context;
};
